import { hashHistory } from 'react-router';

import { CollectionRestaurantSummary } from '../../core/api/restaurant/restaurant.types';
import { AppConfig } from '../../core/api/whitelabel/whitelabel.types';
import { storage as storageService } from '../../weborder/services/storageServices';
import { Utilities } from '../../weborder/Utilities';

const hasDeviceId = (): boolean => {
  const deviceId = storageService.getItem('flipdish-device-id');
  return deviceId !== null;
};

const isAppleDevice = (): boolean => {
  const userAgent =
    navigator.vendor &&
    navigator.vendor.indexOf('Apple') > -1 &&
    navigator.userAgent;

  return !!userAgent;
};

const getCollectionLink = (
  appConfig: AppConfig,
  collectionSummaries: CollectionRestaurantSummary[],
): string => {
  if (appConfig.DisplayPickupRestaurantListScreen) {
    return '/collection';
  }

  const [skipToStore] = collectionSummaries.filter(
    (c) => c.SkipToThisPhysicalRestaurant,
  );

  if (!skipToStore) {
    return '/collection';
  }

  return `/restaurant/${skipToStore.VirtualRestaurantId}/collection/${skipToStore.PhysicalRestaurantId}`;
};

const isValidCustomStaticMenuPath = (path: string): boolean => {
  const validStaticMenuPath =
    /^menu\/[0-9]+\/(collection|delivery){1}\/[0-9]+$/;
  return !!path.match(validStaticMenuPath)?.length;
};

const redirectToStore = (
  configData: AppConfig,
  collectionSummaries: CollectionRestaurantSummary[],
  setRestaurantUrl: (url: string) => void,
  showRestaurantList: boolean,
  vrId: number,
): void => {
  const initialScreen = Utilities.extraOption('data-initial-screen');
  const redirectToMenuPreview = !showRestaurantList && initialScreen;

  if (
    !configData.PickupEnabled &&
    configData.DisplayDeliveryRestaurantListScreen
  ) {
    hashHistory.replace('/delivery');
  } else if (
    !configData.DeliveryEnabled &&
    configData.DisplayPickupRestaurantListScreen
  ) {
    const collectionPath = getCollectionLink(configData, collectionSummaries);
    hashHistory.replace(collectionPath);
  } else if (redirectToMenuPreview) {
    let menuPreviewUrl = `/menu/${vrId}`;

    if (isValidCustomStaticMenuPath(initialScreen)) {
      menuPreviewUrl = initialScreen;
    }

    setRestaurantUrl(menuPreviewUrl);
    hashHistory.replace(menuPreviewUrl);
  } else {
    hashHistory.replace('/where');
  }
};

const redirectToUnavailable = (): void => {
  hashHistory.replace('/unavailable');
};

export const setCookieUtils = {
  getCollectionLink,
  hasDeviceId,
  isAppleDevice,
  isValidCustomStaticMenuPath,
  redirectToStore,
  redirectToUnavailable,
};
